export class AnswerStatus {
  static none = 0;
  static approved = 1;
  static disapproved = 2;
}
